import { ArrowForwardIcon, Button, Container, Flex, lightColors, useWindowDimensions } from '@pancakeswap/uikit'
import Image from 'next/image'
import Link from 'next/link'
import { useMemo } from 'react'
import styled from 'styled-components'
import { dackieColors } from 'utils/dackieConfigs'
import useTheme from "hooks/useTheme";
import TextAnimation from './banerTextTransform'
import DackiePartnerSocial from './socials'

const HomeWrapper = styled.div<{ wExt?: number }>`
  width: 100%;
  height: ${(props) => (props.wExt ? `calc(100vh - ${props.wExt}px)` : 'calc(100vh - 225px)')};
  overflow: hidden;
  /* @media screen and (max-width: 515px) {
    height: calc(80vh);
  } */
  /* height: calc(100vh - (75px + env(safe-area-inset-bottom))); */
`

const SubTitle = styled.span`
  color: ${({ theme }) => theme.colors.contrast};
`

const Homebanner = () => {
  const { width } = useWindowDimensions()
  const { isDark, setTheme } = useTheme()

  const turnPxScreen = useMemo(() => {
    if (width >= 992) {
      return 100
    }
    if (width < 992 && width >= 515) {
      return 150
    }
    // if (width <768  && width >= 515) {
    //   return 150
    // }
    return 225
  }, [width])

  return (
    <HomeWrapper wExt={turnPxScreen}>
      <BannerWrapper>
        <Container style={{ height: '100%' }}>
          <BannerPosition>
            <Bannertext>
              <TextAnimation />
              <div className="des">
                <Description>
                  <SubTitle>Swap and earn with the most trusted DEX on</SubTitle>{' '}
                  <span className="base-extend">
                    <Flex style={{ gap: 8, alignItems: 'center' }}>
                      <div
                        style={{
                          width: 28,
                          height: 28,
                          overflow: 'hidden',
                          position: 'relative',
                        }}
                      >
                        <Image
                          src="/images/home/dackie/BASE_LOGO.png"
                          alt=""
                          objectFit="contain"
                          layout="fill"
                          quality="100"
                        />
                      </div>
                      <SubTitle>BASE</SubTitle>
                    </Flex>
                  </span>
                </Description>
              </div>
              <Flex style={{ gap: 30, flexWrap: 'wrap' }}>
                <OutderIconList>
                  <DackiePartnerSocial isDark={isDark} />
                </OutderIconList>
                <Link href="/swap">
                  <LaunchBtn>
                    <Flex
                      style={{
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      <span>Launch App</span>
                      <ArrowForwardIcon color={dackieColors.black} />
                    </Flex>
                  </LaunchBtn>
                </Link>
              </Flex>
            </Bannertext>
          </BannerPosition>
        </Container>
      </BannerWrapper>
    </HomeWrapper>
  )
}

export default Homebanner

const OutderIconList = styled.div``

const Description = styled.div`
  line-height: 32px;
  align-items: flex-end;
  font-size: 32px;

  .base-extend {
    position: relative;
    bottom: -2px;
    left: 2px;
    display: inline-block;
  }

  @media screen and (max-width: 515px) {
    font-size: 22px;
    .base-extend {
      bottom: -4px;
    }
  }
`

const LaunchBtn = styled(Button)`
  height: 40px;
  color: ${dackieColors.black};
  background-color: ${dackieColors.launchBtn};
  box-shadow: ${dackieColors.btnShadow};
`

const Bannertext = styled.div`
  padding: 2rem;

  h1 {
    font-size: 4.5rem;
    font-weight: 700;
    color: ${lightColors.primary};
    white-space: nowrap;
  }

  .des {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 20px 0 30px 0;
    color: ${dackieColors.black};
  }

  @media screen and (max-width: 515px) {
    padding: 0;
    h1 {
      font-size: 3rem;
    }
  }
`

const BannerPosition = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 2px;
`

const BannerWrapper = styled.div`
  background: url(
    ${({ theme }) => (theme.isDark ? '/images/home/dackie/bg_banner_dark.jpg' : '/images/home/dackie/bg_banner.jpg')}
  ) no-repeat left top;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;

  &::after {
    position: absolute;
    width: 100%;
    height: 100%;
    content: '';
    inset: 0;
    /* backdrop-filter: blur(4px); */
    z-index: -1;
    background: linear-gradient(
            ${({ theme }) => (theme.isDark ? `180deg, rgba(22, 82, 240, 0.1) 0%, rgba(16, 21, 48, 1) 100%` : `180deg, rgba(22, 82, 240, 0.3) 0%, rgba(241, 245, 255, 1) 100%`)}
            
    );
  }
`
